(function () {
  async function getCartQuantity(variantId) {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    return cart.items
      .filter((item) => String(item.variant_id) === String(variantId))
      .reduce((sum, item) => sum + item.quantity, 0);
  }

  function setDisabled(el, disabled) {
    if (!el) return;
    el.disabled = disabled;
    el.classList.toggle('cart-quantity-limit--disabled', disabled);
  }

  async function applyLimit(wrapper) {
    const variantId = wrapper.dataset.variantId;
    const inventoryQuantity = parseInt(wrapper.dataset.inventoryQuantity, 10);
    if (!variantId || Number.isNaN(inventoryQuantity)) return;

    const input = wrapper.querySelector('[name="quantity"]');
    const minusButton = wrapper.querySelector('button[name="minus"]');
    const plusButton = wrapper.querySelector('button[name="plus"]');
    if (!input) return;

    const form = input.form;
    const submitButtons = form
      ? [...form.querySelectorAll('[type="submit"]')]
      : [];

    const message = wrapper.parentElement
      ? wrapper.parentElement.querySelector('[data-cart-quantity-limit-message]')
      : null;

    let inCartQuantity = 0;
    try {
      inCartQuantity = await getCartQuantity(variantId);
    } catch (e) {
      console.error(e);
      return;
    }

    const remaining = Math.max(inventoryQuantity - inCartQuantity, 0);
    const soldOut = remaining <= 0;

    if (input.type === 'number') {
      input.max = remaining;
      if (parseInt(input.value, 10) > remaining) {
        input.value = Math.max(remaining, 1);
      }
    }

    setDisabled(input, soldOut);
    setDisabled(minusButton, soldOut);
    setDisabled(plusButton, soldOut);
    submitButtons.forEach((btn) => setDisabled(btn, soldOut));
    wrapper.classList.toggle('cart-quantity-limit--disabled', soldOut);

    if (message) message.hidden = !soldOut;
  }

  function applyAllLimits() {
    document
      .querySelectorAll('[data-cart-quantity-limit][data-inventory-tracked="true"]')
      .forEach((wrapper) => applyLimit(wrapper));
  }

  document.addEventListener('DOMContentLoaded', applyAllLimits);
  document.addEventListener('cart:refresh-needed', applyAllLimits);
  window.addEventListener('pageshow', applyAllLimits);
})();
